/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2025-02-13 09:33:17
 * @LastEditors: linxi
 * @LastEditTime: 2025-02-13 13:56:58
 */

import { createAsyncThunk } from '@reduxjs/toolkit'
import _ from 'lodash'
import { api, sendAsync } from '../../app/applicationSlice'
import { RootState, RootThunkApi } from '../../app/store'
import * as T from '../../services/AiTuning'
import {AIRecordDetail, AIRecordDetailParams} from "../../services/AiTuning";

export const getAIListAsync = createAsyncThunk<
  void,
  T.AIListParams,
  RootThunkApi
>('AI/getAIListAsync', async (params, api) => {
  return sendAsync(T.AIList(params), api)
})
export const getAIRecordDetailAsync = createAsyncThunk<
    void,
    T.AIRecordDetailParams,
    RootThunkApi
    >('AI/getAIRecordDetailAsync', async (params, api) => {
    return sendAsync(T.AIRecordDetail(params), api)
})

export const getAIDetailAsync = createAsyncThunk<any, void, RootThunkApi>(
  'AI/getAIDetailAsync',
  async (params, api) => {
    return sendAsync(T.AIDetail(), api)
  }
)

export const getAIDetailSubmitAsync = createAsyncThunk<
  void,
  T.AIDetailParams,
  RootThunkApi
>('AI/getAIDetailSubmitAsync', async (params, api) => {
  return sendAsync(T.AIDetailSubmit(params), api)
})